import { Modal } from "antd";
import type { Dispatch, ReactNode, SetStateAction } from "react";
import { useIntl } from "react-intl";

type Props = {
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
  children: ReactNode;
};

const AddPlayerToRosterModal = ({ open, setOpen, children }: Props) => {
  const { formatMessage } = useIntl();

  return (
    <Modal
      open={open}
      title={formatMessage({ id: "roster.add" })}
      cancelText={formatMessage({ id: "cancel" })}
      onCancel={() => setOpen(false)}
      okButtonProps={{ hidden: true }}
      destroyOnClose
      width={800}
    >
      {children}
    </Modal>
  );
};

export default AddPlayerToRosterModal;
